export default __webpack_public_path__ + "static/media/rentegningIkon.cd533f3d.png";